"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.createLinkElement = createLinkElement;
exports.createScriptElement = createScriptElement;
exports.filesAppender = filesAppender;
exports.tagAppender = tagAppender;
exports.unloadStyles = unloadStyles;
var _moduleRegistry = _interopRequireDefault(require("./module-registry"));
var _ReactModuleContainerErrors = require("./ReactModuleContainerErrors");
var requireCache = {};
function noprotocol(url) {
  return url.replace(/^.*:\/\//, '//');
}
function createLinkElement(url) {
  var fileref = document.createElement('LINK');
  fileref.setAttribute('rel', 'stylesheet');
  fileref.setAttribute('type', 'text/css');
  fileref.setAttribute('href', url);
  return fileref;
}
function createScriptElement(url, crossorigin) {
  var fileref = document.createElement('SCRIPT');
  fileref.setAttribute('type', 'text/javascript');
  fileref.setAttribute('src', url);
  if (crossorigin) {
    fileref.setAttribute('crossorigin', 'anonymous');
  }
  return fileref;
}
function tagAppender(url, filetype, crossorigin) {
  var styleSheets = document.styleSheets;
  return requireCache[url] = new Promise(function (resolve, reject) {
    if (window.requirejs && filetype === 'js') {
      window.requirejs([url], resolve, reject);
      return;
    } else if (url in requireCache) {
      // requireCache[url].then(resolve, reject);
      // return;
    }
    var fileref = filetype === 'css' ? createLinkElement(url) : createScriptElement(url, crossorigin);
    var done = false;
    document.getElementsByTagName('head')[0].appendChild(fileref);
    fileref.onerror = function () {
      fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
      delete requireCache[url];
      _moduleRegistry["default"].notifyListeners('reactModuleContainer.error', new _ReactModuleContainerErrors.FileAppenderLoadError(url));
      reject(new Error("Could not load URL " + url));
    };
    fileref.onload = fileref.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true;
        fileref.onerror = fileref.onload = fileref.onreadystatechange = null;
        resolve(fileref);
      }
    };
    if (filetype === 'css' && navigator.userAgent.match(' Safari/') && !navigator.userAgent.match(' Chrom') && navigator.userAgent.match(' Version/5.')) {
      var attempts = 20;
      var interval = setInterval(function () {
        for (var i = 0; i < styleSheets.length; i++) {
          if (noprotocol("" + styleSheets[i].href) === noprotocol(url)) {
            clearInterval(interval);
            fileref.onload();
            return;
          }
        }
        if (--attempts === 0) {
          clearInterval(interval);
          fileref.onerror();
        }
      }, 50);
    }
  });
}
function append(file, crossorigin) {
  return tagAppender(file, file.split('.').pop(), crossorigin);
}
function onCatch(error, optional) {
  if (optional === void 0) {
    optional = false;
  }
  return optional ? Promise.resolve() : Promise.reject(error);
}
function appendEntry(entry, crossorigin) {
  if (typeof entry === 'object') {
    var optional = entry.optional,
      url = entry.url;
    return append(url, crossorigin)["catch"](function (err) {
      return onCatch(err, optional);
    });
  } else {
    return append(entry, crossorigin)["catch"](function (err) {
      return onCatch(err);
    });
  }
}
function filesAppender(entries, crossorigin) {
  return Promise.all(entries.map(function (entry) {
    if (Array.isArray(entry)) {
      return entry.reduce(function (promise, entryItem) {
        return promise.then(function () {
          return appendEntry(entryItem, crossorigin);
        });
      }, Promise.resolve());
    } else {
      return appendEntry(entry, crossorigin);
    }
  }));
}
function unloadStyles(fileNodes) {
  Array.from(fileNodes).filter(function (node) {
    return node && node.rel === 'stylesheet';
  }).forEach(function (node) {
    node.parentNode.removeChild(node);
  });
}